module.exports = __webpack_public_path__ + "img/book-now-btn.d3d43302.png";